export const fuzzyInputValueToStep = (inputValue: number, filterRanges: number[]): number => {
  let left = 0;
  let right = filterRanges.length - 1;

  while (left < right) {
    const mid = Math.floor((left + right) / 2);

    if (filterRanges[mid] < inputValue) left = mid + 1;
    else right = mid;
  }
  return left;
};

export const removeAllCommasFromNumber = (inputValue: string): number =>
  Number(inputValue.replace(/\D/g, '').split(',').join(''));

export const formatTextInputNumber = (inputValue: number): string =>
  new Intl.NumberFormat('en-AU').format(inputValue).toString();
